import { UserGroupDTO, UserGroupNotificationDTO } from '@/lib/types/userGroup'
import api from './axios'

const baseUrl = '/rest/v1/groups'

export async function getUserGroups(params?: PagedRequestParams): Promise<PagedResult<UserGroupDTO>> {
    const body = params ? {
        params: {
            offset: params.offset,
            limit: params.limit,
            sortField: params.sortField,
            sortOrder: params.sortOrder,
            ...params.filters
        }
    } : {}
    const res = await api.get(baseUrl, body)
    return res.data
}

export async function getUserGroupById(id: string): Promise<ErrorMessage | UserGroupDTO> {
    const res = await api.get(`${baseUrl}/${id}`)
    return res.data
}

export async function createUserGroup(data: UserGroupDTO): Promise<ErrorMessage | UserGroupDTO> {
    const { id, ...body } = data
    const res = await api.post(baseUrl, body)
    return res.data
}

export async function updateUserGroup(data: UserGroupDTO): Promise<ErrorMessage | UserGroupDTO> {
    const { id, ...body } = data
    const res = await api.put(`${baseUrl}/${id}`, body)
    return res.data
}

export async function deleteUserGroup(id: string): Promise<ErrorMessage | void> {
    return await api.delete(`${baseUrl}/${id}`);
}

export async function getUserGroupNotifications(id: string): Promise<Record<string, UserGroupNotificationDTO>> {
    const res = await api.get<Record<string, UserGroupNotificationDTO>>(`${baseUrl}/notifications/${id}`)
    return res.data
}

export async function saveUserGroupNotifications(id: string, data: UserGroupNotificationDTO[]): Promise<ErrorMessage | void> {
    return await api.post(`${baseUrl}/notifications/${id}`, data)
}